const settings = {
  api: "https://premint-api.gmstudios.gg/api/v1/project/random-ravers-og/",
  whitelistApi:
    "https://premint-api.gmstudios.gg/api/v1/whitelist/random-ravers-og/",
};
export { settings };
